export default "__VITE_ASSET__D0VRG1hv__"